import { ReactNode } from "react";
import { LoadingStatus } from "src/libs/fetcher";
import { useCardThemed } from "./useCardThemed";
import { CardThemeIdentifier } from "./card-theme-utils";

export type ThemeBodyTextProps = {
  themeId?: CardThemeIdentifier;
  children: ReactNode;
};

export function ThemeBodyText({ themeId, children }: ThemeBodyTextProps) {
  const { theme, status } = useCardThemed(themeId);

  if (status !== LoadingStatus.SUCCESS) {
    return null;
  }

  return <span style={{ color: theme.bodyTextColor }}>{children}</span>;
}
